import createHighVelocityContext from '../../../utils/createHighVelocityContext'

const initialState = { searchResults: [], loading: true, error: null }
const { Provider, useStore } = createHighVelocityContext(initialState)

export { Provider, useStore }
